<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-city map-marker"
            :class="{ active: active === fmLatlng }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @click="onClick"
            v-bind="$attrs"
        >
            <a v-if="data.link" :href="data.link" rel="noopener noreferrer">
                <div class="marker-address">{{ data.address }}</div>
                <div
                    ref="pop"
                    class="marker-pop"
                    :class="{ bottom: popBottom }"
                    :style="popStyle"
                >
                    <div
                        class="detail mg-color-bg"
                        :class="{ 'no-price': !data.price }"
                    >
                        <p class="address">{{ data.address }}</p>
                        <span class="info">{{ data.detail || '' }}</span>
                    </div>
                </div>
            </a>
        </div>
    </Teleport>
</template>

<script>
import Marker from './marker';
export default {
    mixins: [Marker],
    data: function() {
        return {
            type: 'city'
        };
    }
};
</script>
